export default __webpack_public_path__ + "static/portfolio-cover-6-0657d3c594bce080ee4547fccd3984b8.jpg";